/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiVendorRfqCancelRfqDetailGet$Params {
  pk?: string;
  remark?: string;

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
}

export function apiVendorRfqCancelRfqDetailGet(http: HttpClient, rootUrl: string, params?: ApiVendorRfqCancelRfqDetailGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiVendorRfqCancelRfqDetailGet.PATH, 'get');
  if (params) {
    rb.query('pk', params.pk, {});
    rb.query('remark', params.remark, {});
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiVendorRfqCancelRfqDetailGet.PATH = '/api/vendor/rfq/CancelRfqDetail';
